export default "__VITE_ASSET__BHk5QnVo__"